export const ANALYTICS_API_BASE_URL = (process.env.REACT_APP_ANALYTICS_API_BASE_URL || '').replace(/\/$/, '');
